import React, { useState } from "react";
import { Modal } from "../../Modal";
import * as S from "./styles";
import { CircularProgress as Loading } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export function ModalConfirmAudio({
  showModal,
  handleCancel,
  handleConfirm,
  audio,
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  async function handleClick() {
    setLoading(true);

    await handleConfirm();

    setLoading(false);
  }

  return (
    <Modal
      open={showModal}
      size="medium"
      disableBackdropClick
      onClose={handleCancel}
    >
      <S.Container>
        <S.Title>
          <span>{t("Chat:audio_attachment.confirm")}</span>
        </S.Title>

        <S.Content>
          {audio && (
            <audio controls>
              <source
                src={URL.createObjectURL(audio)}
                type="audio/ogg; codecs=opus"
              />
            </audio>
          )}
        </S.Content>

        <S.Actions>
          <S.CancelAction>
            <S.BorderedButton color="#ED5565" onClick={handleCancel}>
              <S.TrashIcon />
            </S.BorderedButton>

            <S.ActionTitle color="#ED5565">
              {t("Chat:audio_attachment.cancel")}
            </S.ActionTitle>
          </S.CancelAction>

          <S.SendAction>
            <S.BorderedButton
              disabled={loading}
              color="#63afef"
              onClick={handleClick}
            >
              {loading ? <Loading /> : <S.SendIcon />}
            </S.BorderedButton>

            <S.ActionTitle color="#63afef">
              {t("Chat:audio_attachment.send")}
            </S.ActionTitle>
          </S.SendAction>
        </S.Actions>
      </S.Container>
    </Modal>
  );
}
